<yc-modal *ngIf="formGroup"
  [modalHeader]="modalHeader"
  [modalSubHeader]="programName"
  [primaryButtonText]="primaryButtonText"
  [primaryDisabled]="formGroup.invalid"
  [cancelButtonText]="'common:btnCancel' | ycI18n"
  (onCancel)="onCancel()"
  (onPrimaryClick)="onSubmit()">
  <div class="d-flex mb-3">
    <div *ngIf="modalData.ids.length !== 1 ||
      context === 'archiveProgram'"
      class="flex-fill">
      <div>
        <yc-i18n
          [key]="isNomination ?
            'common:lblTotalNominations' :
            'common:lblTotalApplications'"
          [defaultValue]="isNomination ?
            'Total Nominations' :
            'Total Applications'">
        </yc-i18n>
      </div>
      <div class="header-stats">
        <yc-fa
          icon="clipboard-list"
          [light]="true"
          class="text-link me-2">
        </yc-fa>
        <ng-container *ngIf="context === 'archiveApp' || context === 'unarchiveApp'">
          {{ modalData.ids.length }}
        </ng-container>
        <ng-container *ngIf="context === 'archiveProgram'">
          {{ modalData.unarchivedApplicationCount | number }}
        </ng-container>
      </div>
    </div>
    <div *ngIf="modalData.ids.length === 1 &&
      (context === 'archiveApp' || context === 'unarchiveApp')"
      class="flex-fill">
      <div>
        <yc-i18n
          [key]="isNomination ?
            'GLOBAL:textNominationID' :
            'common:textApplicationId'"
          [defaultValue]="isNomination ?
            'Nomination ID' :
            'Application ID'">
        </yc-i18n>
      </div>
      <div class="header-stats">
        <yc-fa
          icon="clipboard-list"
          [light]="true"
          class="text-link me-2">
        </yc-fa>
        {{ modalData.ids[0] }}
      </div>
    </div>
    <ng-container *ngIf="!isNomination">
      <div class="flex-fill">
        <div>
          <yc-i18n
            key="AWARDS:textTotalAwards"
            defaultValue="Total Awards">
          </yc-i18n>
        </div>
        <div class="header-stats">
          <yc-fa
            icon="gift"
            [light]="true"
            class="text-link me-2">
          </yc-fa>
          {{ modalData.totalAwards | gcMoney }}
        </div>
      </div>
      <div class="flex-fill">
        <div>
          <yc-i18n
            key="GLOBAL:textTotalPaymentsUpperCase"
            defaultValue="Total Payments">
          </yc-i18n>
        </div>
        <div class="header-stats">
          <yc-fa
            icon="money-bill-wave-alt"
            [light]="true"
            class="text-link me-2">
          </yc-fa>
          {{ modalData.totalPayments | gcMoney }}
        </div>
      </div>
      <div class="flex-fill">
        <div>
          <yc-i18n
            key="GLOBAL:textPaymentsAvailableForProcessing"
            defaultValue="Payments Available for Processing">
          </yc-i18n>
        </div>
        <div class="header-stats">
          <yc-fa
            icon="money-bill"
            [light]="true"
            class="text-link me-2">
          </yc-fa>
          {{ modalData.paymentsAvailableForProcessing | gcMoney }}
        </div>
      </div>
    </ng-container>
  </div>
  <div>
    {{ summaryText }}
    <div
      *ngIf="context === 'archiveApp'" 
      class="d-flex mt-1">
      <ul>
        <li>
          {{ grantManagersMakeChangesText }}
        </li>
        <li>
          {{ applicantsMayNotMakeChangesText }}
        </li>
        <li>
          {{ archivedPaymentsCannotBeAddedText }}
        </li>
      </ul>
    </div>
    <div *ngIf="context === 'unarchiveApp'" 
      class="d-flex mt-1">
      <ul>
        <li>
          {{ paymentsCanBeAdded }}
        </li>
        <li>
          {{ applicantsCanMakeChanges }}
        </li>
      </ul>
    </div>
  </div>
  <ng-container
    [formGroup]="formGroup">
    <!-- Reason -->
    <div
      *ngIf="showReason" 
      class="row mb-3">
      <div class="col-md-12">
        <yc-typeahead-select
          name="code"
          [items]="reasonOptions"
          [label]="'APPLY:textReasonForArchiving' | ycI18n: 'Reason for archiving'">
        </yc-typeahead-select>
      </div>
    </div>

    <!-- Comment -->
    <div *ngIf="showComment" 
      class="row">
      <div class="col-md-12">
        <yc-textarea
          name="notes"
          [label]="'common:labelComment' | ycI18n: 'Comment'"
          [maxLength]="2000">
        </yc-textarea>
      </div>
    </div>
  </ng-container>
</yc-modal>